var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStopped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(-2807.938 -446.618)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 16,
    height: 16,
    transform: "translate(2807.938 446.618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M2816.072,461.106a6.5,6.5,0,1,1,6.5-6.5A6.508,6.508,0,0,1,2816.072,461.106Zm0-11.8a5.3,5.3,0,1,0,5.3,5.3A5.3,5.3,0,0,0,2816.072,449.308Zm-.845,7.578v-4.561a.6.6,0,1,0-1.2,0v4.561a.6.6,0,1,0,1.2,0Zm2.89,0v-4.561a.6.6,0,1,0-1.2,0v4.561a.6.6,0,1,0,1.2,0Z",
    fill: "#ff3056"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopped);
export default __webpack_public_path__ + "static/media/icon-stopped.d5425bb13f03fa428ce74077e3925ba8.svg";
export { ForwardRef as ReactComponent };